import axiosInstance from '../../utils/axiosConfig';
import axios from "axios";
export const GET_CLAIM = "GET_CLAIM";
export const CREATE_CLAIM = "CREATE_CLAIM";
export const DELETE_CLAIM = "DELETE_CLAIM";
export const UPDATE_CLAIM = "UPDATE_CLAIM";
export const GET_AGENCY = "GET_AGENCY";
export const GET_AGENCY_ERROR = "GET_AGENCY_ERROR";
export const CLEAR_CLAIMS = "CLEAR_CLAIMS";
export const CREATE_AGENCY_REQUEST = 'CREATE_AGENCY_REQUEST';
export const CREATE_AGENCY_SUCCESS = 'CREATE_AGENCY_SUCCESS';
export const CREATE_AGENCY_FAILURE = 'CREATE_AGENCY_FAILURE';
export const DELETE_AGENCY_REQUEST = 'DELETE_AGENCY_REQUEST';
export const DELETE_AGENCY_SUCCESS = 'DELETE_AGENCY_SUCCESS';
export const DELETE_AGENCY_FAILURE = 'DELETE_AGENCY_FAILURE';
export const UPDATE_AGENCY_REQUEST = 'UPDATE_AGENCY_REQUEST';
export const UPDATE_AGENCY_SUCCESS = 'UPDATE_AGENCY_SUCCESS';
export const UPDATE_AGENCY_FAILURE = 'UPDATE_AGENCY_FAILURE';
export const GET_CLAIM_COUNT_BY_STATUS = "GET_CLAIM_COUNT_BY_STATUS";
export const GET_CLAIM_COUNT_BY_MANAGEMENT_TYPE = "GET_CLAIM_COUNT_BY_MANAGEMENT_TYPE";
export const FILTER_CLAIM_REQUEST = "FILTER_CLAIM_REQUEST";
export const FILTER_CLAIM_SUCCESS = "FILTER_CLAIM_SUCCESS";
export const FILTER_CLAIM_FAILURE = "FILTER_CLAIM_FAILURE";
export const UPDATE_CLAIM_SUCCESS = "UPDATE_CLAIM_SUCCESS";
export const UPDATE_CLAIM_FAILURE = "UPDATE_CLAIM_FAILURE";
export const UPDATE_CLAIM_STATUS_SUCCESS = "UPDATE_CLAIM_STATUS_SUCCESS";

// Référence stable : les consommateurs relancent getAllClaims dès que claimData change
// d'identité, donc renvoyer un [] neuf à chaque échec boucle indéfiniment.
const NO_CLAIMS = [];

export function getAllClaims() {
  return async (dispatch) => {
    const token = localStorage.getItem('token');
    await axiosInstance.post(
      `${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/claim/FilterClaim`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
      .then((response) => {
        // FilterClaim renvoie l'enveloppe { data, page, limit, total } — les consommateurs attendent un tableau
        const claims = Array.isArray(response.data)
          ? response.data
          : Array.isArray(response.data?.data)
            ? response.data.data
            : NO_CLAIMS;
        dispatch({
          type: GET_CLAIM,
          payload: claims.length ? claims : NO_CLAIMS,
        });
      })
      .catch((error) => {
        console.log("error", error);
        dispatch({
          type: GET_CLAIM,
          payload: NO_CLAIMS,
        });
      });
  };
}



export function getAllAgency() {
  return async (dispatch) => {
    try {
      // La gateway met en cache les GET /api/claim 5 min (node-cache + Cache-Control max-age=300) :
      // sans paramètre unique, une agence créée/modifiée n'apparaît qu'après expiration du cache
      const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/agency/getListOfAgency`, { params: { _: Date.now() } });
      dispatch({
        type: GET_AGENCY,
        payload: response.data,
      });
      return response.data
    } catch (error) {
      console.error("Error fetching agencies:", error);
      dispatch({
        type: GET_AGENCY_ERROR,
      });
    }
  };
}




/**
 * Creates a claim with its policy, parties, vehicles and expert mission through
 * the gateway orchestration used by the MAE ETL (/api/claimcreation).
 * Throws on HTTP error (409 when the claim number already exists).
 */
export const createCompleteClaim = (claimData) => async () => {
  // claimcreation is mounted next to /api/claim on the gateway
  const baseUrl = process.env.REACT_APP_BACKEND_URL_MS_CLAIM.replace(/\/claim$/, '');
  const response = await axiosInstance.post(`${baseUrl}/claimcreation/create-complete-claim`, claimData);
  return response.data;
};

export const getClaimCountByManagementType = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axiosInstance.get(
      `${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/claim/CountByManagementType`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // 🔥 TRANSFORM OBJECT → ARRAY
    const formatted = Object.entries(response.data || {}).map(
      ([managementType, count]) => ({
        managementType,
        count,
      })
    );

    dispatch({
      type: GET_CLAIM_COUNT_BY_MANAGEMENT_TYPE,
      payload: formatted,
    });

    return formatted;
  } catch (error) {
    console.error("Error fetching claim count by management type:", error);

    dispatch({
      type: GET_CLAIM_COUNT_BY_MANAGEMENT_TYPE,
      payload: [],
    });
  }
};
export const updateStatusClaim = (claimNumber, status) => async (dispatch) => {
  const response = await axiosInstance.put(
    `${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/claim/UpdateStatus/${claimNumber}`,
    { status }
  );
  dispatch({
    type: UPDATE_CLAIM_STATUS_SUCCESS,
    payload: { claimNumber, status },
  });
  return response.data;
};

export const getClaimCountByStatus = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axiosInstance.get(
      `${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/claim/CountByStatus`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // 🔥 TRANSFORM OBJECT → ARRAY
    const formatted = Object.entries(response.data || {}).map(
      ([status, count]) => ({
        status,
        count,
      })
    );

    dispatch({
      type: GET_CLAIM_COUNT_BY_STATUS,
      payload: formatted,
    });

    return formatted;
  } catch (error) {
    console.error("Error fetching claim count by status:", error);

    dispatch({
      type: GET_CLAIM_COUNT_BY_STATUS,
      payload: [],
    });
  }
};


export const filterClaimm = (filters, page = 1, limit = 20) => async (dispatch) => {
  try {
    dispatch({ type: FILTER_CLAIM_REQUEST });

    const token = localStorage.getItem("token");

    const response = await axiosInstance.post(
      `${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/claim/FilterClaim`,
      {
        filters,
        pagination: { page, limit },
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({
      type: FILTER_CLAIM_SUCCESS,
      payload: response.data,
    });

    return response.data;
  } catch (error) {
    console.error("Error filtering claims:", error);

    dispatch({
      type: FILTER_CLAIM_FAILURE,
      payload: error.response?.data || error.message,
    });

    throw error;
  }
};

export const createAgency = (agencyData) => async (dispatch) => {
  dispatch({ type: CREATE_AGENCY_REQUEST });

  try {
    const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/agency/createAgency`, agencyData);
    dispatch({
      type: CREATE_AGENCY_SUCCESS,
      payload: response.data,
    });
    return response.data
  } catch (error) {
    dispatch({
      type: CREATE_AGENCY_FAILURE,
      payload: error.response ? error.response.data : error.message,
    });
    throw error
  }
};

export const deleteAgency = (agencyId) => async (dispatch) => {
  dispatch({ type: DELETE_AGENCY_REQUEST });

  try {
    const response = await axiosInstance.delete(`${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/agency/deleteAgency/${agencyId}`);
    dispatch({
      type: DELETE_AGENCY_SUCCESS,
      payload: response.data,
    });
    return response.data
  } catch (error) {
    dispatch({
      type: DELETE_AGENCY_FAILURE,
      payload: error.response ? error.response.data : error.message,
    });
    throw error
  }
};

export const updateAgency = (agencyId, updatedData) => async (dispatch) => {
  dispatch({ type: UPDATE_AGENCY_REQUEST });

  try {
    const response = await axiosInstance.put(
      `${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/agency/updateAgency/${agencyId}`,
      updatedData
    );
    dispatch({
      type: UPDATE_AGENCY_SUCCESS,
      payload: response.data,
    });
    return response.data
  } catch (error) {
    dispatch({
      type: UPDATE_AGENCY_FAILURE,
      payload: error.response ? error.response.data : error.message,
    });
    throw error
  }
};


export const getClaimDetails = (claimNumber) => async (dispatch) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/claim/GetClaimDetails/${claimNumber}`;
    const response = await axiosInstance.get(url);
    return response.data
  } catch (error) {
    dispatch({
      type: 'GET_CLAIM_DETAILS',
      payload: error.response ? error.response.data : 'Server error',
    });
  }
}

export function buildDaaq({ existingDaaq, managementType = "CLASSIQUE", agency, addInspector, removeInspector }) {
  let base = existingDaaq && existingDaaq.startsWith("/claim/")
    ? existingDaaq
    : `/claim/${(managementType || "CLASSIQUE").toLowerCase()}/${agency || ""}`;
  const segs = (base || "").split("/").filter(Boolean);
  segs[0] = "claim";
  segs[1] = (managementType || "CLASSIQUE").toLowerCase();
  segs[2] = agency || segs[2] || "";
  let inspectors = [];
  const last = segs[segs.length - 1];
  if (last && last.endsWith(",")) {
    inspectors = last.slice(0, -1).split(",").filter(Boolean);
    segs.pop();
  }
  if (addInspector && !inspectors.includes(addInspector)) inspectors.push(addInspector);
  if (removeInspector) inspectors = inspectors.filter((i) => i !== removeInspector);
  const rebuilt = `/${segs.join("/")}${inspectors.length ? "/" + inspectors.join(",") + "," : ""}`;
  return rebuilt;
}

export const updateClaimDaaq = ({
  claimNumber,
  claimUid,
  existingDaaq,
  managementType = "CLASSIQUE",
  agency,
  addInspector,
  removeInspector,
}) => async (dispatch) => {
  try {
    let currentDaaq = existingDaaq;
    if (!currentDaaq) {
      const id = claimNumber || claimUid;
      const claim = await dispatch(getClaimDetails(id));
      currentDaaq = claim?.daaq || null;
      if (!agency && claim) agency = claim?.agency;
    }
    const daaq = buildDaaq({
      existingDaaq: currentDaaq,
      managementType,
      agency,
      addInspector,
      removeInspector,
    });
    const idForUrl = claimNumber || claimUid;
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/claim/UpdateClaim/${idForUrl}`;
    const { data } = await axiosInstance.put(url, { daaq, managementType });
    return data;
  } catch (err) {
    throw err;
  }
};

/**
 * Delete a claim by claimNumber. Backend deletes the claim and its inspection missions.
 * On success, dispatches DELETE_CLAIM (to remove from list) and optionally refreshes the list.
 */
export const deleteClaim = (claimNumber, claimId) => async (dispatch) => {
  try {
    const response = await axiosInstance.delete(
      `${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/claim/DeleteClaim/${encodeURIComponent(claimNumber)}`
    );
    if (response.data && response.data.success) {
      if (claimId) {
        dispatch({ type: DELETE_CLAIM, payload: claimId });
      }
      await dispatch(getAllClaims());
      return response.data;
    }
    throw new Error(response.data?.message || 'Delete failed');
  } catch (error) {
    const message = error.response?.data?.message || error.response?.data?.error || error.message;
    throw new Error(message);
  }
};

export async function fetchClaimDataAppExpert(claimMissionExpertId) {
  try {

    const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL_EXPERT_MISSION}/claims/${claimMissionExpertId}/ClaimData`);
    return response.data;
  } catch (error) {
    console.error("Error fetching claim data:", error);
    throw error;
  }
};




export function clearClaims() {
  return {
    type: CLEAR_CLAIMS,
  };
}


export const createPaymentRepair = (paymentData) => async (dispatch) => {
  dispatch({ type: "CREATE_PAYMENTREPAIR_REQUEST" });

  try {
    const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/paymentRepair/create`, paymentData);
    dispatch({
      type: "CREATE_PAYMENTREPAIR_SUCCESS",
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: "CREATE_PAYMENTREPAIR_FAILURE",
      payload: error.response ? error.response.data : error.message,
    });
  }
};


export const FETCH_PI_CLAIM_DATA_REQUEST = "FETCH_PI_CLAIM_DATA_REQUEST";
export const FETCH_PI_CLAIM_DATA_SUCCESS = "FETCH_PI_CLAIM_DATA_SUCCESS";
export const FETCH_PI_CLAIM_DATA_FAILURE = "FETCH_PI_CLAIM_DATA_FAILURE";

export const fetchPiClaimData = (cin) => async (dispatch) => {
  dispatch({ type: FETCH_PI_CLAIM_DATA_REQUEST });

  try {
    // Step 1: Fetch token
    const tokenResponse = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL_STAR_PARTENAIRE_API_URL}/token`,
      {},
      {
        params: { grant_type: "authorization_code" },
        auth: { username: "DIGITAL_USER", password: "$g5AK3aNf&" },
      }
    );
    const token = tokenResponse.data.accessToken;

    // Step 2: Fetch client data
    const clientResponse = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL_STAR_PARTENAIRE_API_URL}/starpartenaire/api/consultation/client?numDocument=${cin}&typeDocument=CIN`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    const clientData = clientResponse.data;

    // Step 3: Fetch contracts for the client
    const contractsResponse = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL_STAR_PARTENAIRE_API_URL}/starpartenaire/api/consultation/contrat?codeClient=${clientData.codeClient}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    const contracts = contractsResponse.data;

    // Step 4: Fetch claims (sinistres) for each contract
    const sinistresPromises = contracts.map(async (contract) => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL_STAR_PARTENAIRE_API_URL}/starpartenaire/api/consultation/sinistre/entete?numContrat=${contract.numeroContrat}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        console.log("Response sinistres for contract:", contract.numeroContrat, response.data);
        return response.data; // Return the array of sinistres
      } catch (error) {
        console.error(`Error fetching sinistres for contract ${contract.numeroContrat}:`, error);
        return []; // Return an empty array in case of an error
      }
    });

    // Wait for all promises to resolve
    const sinistresResponses = await Promise.all(sinistresPromises);

    // Flatten the array of arrays into a single array
    const sinistres = sinistresResponses.flat();


    // Step 5: Dispatch success with data
    dispatch({
      type: FETCH_PI_CLAIM_DATA_SUCCESS,
      payload: { client: clientData, contracts, sinistres },
    });
  } catch (error) {
    console.error("Error fetching PI claim data:", error);
    dispatch({
      type: FETCH_PI_CLAIM_DATA_FAILURE,
      payload: error.response ? error.response.data : "Server error",
    });
  }
};


export const fetchInvolvedCarByUid = (uid) => async () => {
  try {
    const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/involvedCar/getInvolvedCarByUid/${uid}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching involved car:", error);
    throw error;
  }
};

export const fetchInvolvedPolicyByUid = (uid) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/involvedPolicy/getInvolvedPolicyByUid/${uid}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching involved policy:", error);
    throw error;
  }
};

export const updateClaim = (claimNumber, additionalData) => async (dispatch) => {
  try {
    const response = await axiosInstance.put(
      `${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/claim/UpdateClaim/${claimNumber}`,
      { additionalData }
    );
    // Optionally dispatch an action to update the state in Redux
    dispatch({
      type: 'UPDATE_CLAIM_SUCCESS',
      payload: response.data,
    });

    return response.data; // Return the response data if needed
  } catch (error) {
    console.error("Error updating claim:", error);
    // Optionally dispatch an error action
    dispatch({
      type: 'UPDATE_CLAIM_FAILURE',
      payload: error.message,
    });

    throw error; // Rethrow the error for further handling if needed
  }
};
